import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { VmAdminDetail } from '@/types/dtos/vm/response/vm-admin.dto';

export const GET_VM_DETAIL_QUERY_KEY = 'get-vm-detail-admin';

export const useGetVmDetailQuery = (vmId: string | null) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_VM_DETAIL_QUERY_KEY, vmId],
    queryFn: async () => {
      const token = await getToken();
      return getVmDetail(token ?? '', vmId!);
    },
    enabled: !!vmId,
    retry: false,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
};

const getVmDetail = async (token: string, vmId: string): Promise<VmAdminDetail> => {
  const url = `${import.meta.env.VITE_API_URL}/vm/${vmId}`;
  return (await sendJSONRequest({ url, method: METHOD.GET, token })) as VmAdminDetail;
};
